import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

const BASE_CLASS = "builder-tabs";

function SessionExpired(props) {
  const { header, description } = props;
  const { logout } = useAuth0();

  useEffect(() => {
    const logoutUser = () => {
      localStorage.removeItem("lastActivity"); // Clear inactivity timestamp
      logout();
    };

    const timer = setTimeout(logoutUser, 5000); // Logout after 5 seconds

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [logout]);
  return (
    <div className="container my-100">
      <h1 className="mb-20 text-grey-600">{header || "Session Expired"}</h1>
      <p>
        {description ||
          "You will be logged out due to inactivity. Please login to resume activity."}
      </p>
    </div>
  );
}

export default SessionExpired;
